export const QUOTE = 'Quote'
export const ORDER = 'Order'
export const QUOTATION_SENT = 'quotation-sent'
export const QUOTE_OPEN = 'QuoteOpen'
